import organizationsReducers from './reducer';
import * as organizationActions from './reducer';

export { organizationActions };

export default organizationsReducers;
